<template>
  <div
    class="bridal-item-card"
    :id="id"
    :class="{
      'favorited-on': item.favorited,
      'simulation-on': item.simulation_target,
      'collage-on': item.collage_target,
    }"
  >
    <figure class="bridal-item-card-image-box">
      <img
        v-if="item.image_path"
        :src="item.image_path | appendDomain"
        :alt="$domUtils.decode(item.bridal_item_name)"
        class="bridal-item-card-image"
      >
      <img
        v-if="item.image_url"
        :src="item.image_url"
        :alt="$domUtils.decode(item.bridal_item_name)"
        class="bridal-item-card-image"
      >
      <a
        class="bridal-item-card-image-link"
        href="#"
        @click.prevent="clickImage"
      ></a>
    </figure>
    <div class="bridal-item-card-contents">
      <div class="bridal-item-card-button-box">
        <button
          v-if="collageButtonShow"
          class="bridal-item-card-button bridal-item-card-collage-button"
          :class="{ 'is-on': item.collage_target }"
          :disabled="collageButtonDisabled"
          @click="toggleCollage"
        >
          <i class="fas fa-image"></i>
        </button>
        <button
          v-if="simulationButtonShow"
          class="bridal-item-card-button bridal-item-card-simulation-button"
          :class="{ 'is-on': item.simulation_target }"
          :disabled="simulationButtonDisabled"
          @click="toggleSimulation"
        >
          <i class="fas fa-calculator"></i>
        </button>
        <button
          v-if="favoriteButtonShow"
          class="bridal-item-card-button bridal-item-card-favorite-button"
          :class="{ 'is-on': item.favorited }"
          :disabled="favoriteButtonDisabled"
          @click="toggleFavorite"
        >
          <i class="fas fa-bookmark"></i>
        </button>
      </div>
      <div class="bridal-item-card-header">
        <p class="bridal-item-card-alert" v-if="item.alert_message">
          <i class="fas fa-exclamation-circle"></i>
          <span v-html="item.alert_message"></span>
        </p>
        <p class="bridal-item-card-name" v-html="item.bridal_item_name">
        </p>
        <p class="bridal-item-card-price">
          ¥{{item.retail_price | numFormat}}
        </p>
      </div>
      <div
        class="bridal-item-card-body space-t-2"
        v-html="injectedHTML" ref="content"
      >
      </div>
    </div>
  </div>
</template>

<script>
import { SCHEME, getDomain } from '@/api/theme'
import { sanitizeHTML } from '@/utils/dom'
import initInjectedHTML from '@/utils/init-injected-html'
import numFormat from '@/filters/num-format'

const storagePath = SCHEME + getDomain()

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      required: true
    },
    favoriteButtonShow: {
      type: Boolean,
      default: false
    },
    simulationButtonShow: {
      type: Boolean,
      default: false
    },
    collageButtonShow: {
      type: Boolean,
      default: false
    },
    favoriteButtonDisabled: {
      type: Boolean,
      default: false
    },
    simulationButtonDisabled: {
      type: Boolean,
      default: false
    },
    collageButtonDisabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    injectedHTML() {
      if (!this.item.bridal_item_description) {
        return null
      }
      return sanitizeHTML(this.item.bridal_item_description)
    },
  },
  methods: {
    clickImage() {
      this.$emit('click-image', this.item)
    },
    toggleFavorite() {
      if (this.item.loading) {
        return false
      }
      this.$emit('toggle-favorite', this.item)
    },
    toggleSimulation() {
      if (this.item.loading) {
        return false
      }
      this.$emit('toggle-simulation', this.item)
    },
    toggleCollage() {
      if (this.item.loading) {
        return false
      }
      this.$emit('toggle-collage', this.item)
    },
  },
  filters: {
    numFormat,
    appendDomain(val) {
      return storagePath + val
    },
  },
  watch: {
    injectedHTML: {
      handler() {
        this.$nextTick(() => {
          initInjectedHTML(this.$refs.content)
        })
      },
      immediate: true
    },
  },
}
</script>